import _ from 'lodash';
import{scenarioCatalogueFilterTypes} from '../../constants';


const filterReducers = (state = {filters: {}}, action) => {
    switch (action.type) {
        case scenarioCatalogueFilterTypes().addFilter:
            {let currentAddFilter =
                state.filters[action.name] && state.filters[action.name].length
                    ? state.filters[action.name] : [];
            currentAddFilter.push(action.value);
            const newAddState = Object.assign({}, state.filters, {[action.name]: currentAddFilter});
            return Object.assign({}, state, {filters: newAddState});}

        case scenarioCatalogueFilterTypes().removeFilter:
            {let currentRemoveFilter =
                state.filters[action.name] && state.filters[action.name].length
                    ? state.filters[action.name] : [];
            currentRemoveFilter = _.pull(currentRemoveFilter, action.value);
            const newRemoveState = Object.assign({}, state.filters, {[action.name]: currentRemoveFilter});
            return Object.assign({}, state, {filters: newRemoveState});}

        case scenarioCatalogueFilterTypes().clearFilters:
            return Object.assign({}, state, {filters: {}});

        default:
            return state;
    }
};

export default filterReducers;

